import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';

export const query = gql`
  query GetWaiver($id: Int!) {
    getWaiver(id: $id) {
      id
      name
      waiver_id
      company
      type
      status
      requires_spouse
      requires_minor
      is_minor_waiver
      notes
    }
  }
`;
export default graphql(query, {
  skip: ({ currentWaiver, isOpen }) => !currentWaiver || !isOpen,
  options: ({ currentWaiver }) => {
    return {
      variables: { id: currentWaiver },
      fetchPolicy: 'cache-and-network',
    };
  },
});
